<template>
	<JBox class="s-w-full s-sticky s-top-0">
		<!-- Menu -->
		<JBox class="s-w-full s-flex s-cursor-pointer" v-if="hasSelectedNode">
			<JBox
				class="s-flex-1 s-text-center s-text-sm s-p-3 s-border-b-2 s-border-gray-300"
				:class="{ 's-border-indigo-600': tab === 'content' }"
				@click="selectTab('content')"
			>
				{{ $t("uiEditor.content") }}
			</JBox>
			<JBox
				class="s-flex-1 s-text-center s-text-sm s-p-3 s-border-b-2 s-border-gray-300"
				:class="{ 's-border-indigo-600': tab === 'design' }"
				@click="selectTab('design')"
			>
				{{ $t("uiEditor.design") }}
			</JBox>

			<JBox
				class="s-flex-1 s-text-center s-text-sm s-p-3 s-border-b-2 s-border-gray-300"
				:class="{ 's-border-indigo-600': tab === 'props' }"
				@click="selectTab('props')"
			>
				{{ $t("uiEditor.props") }}
			</JBox>
		</JBox>

		<!-- Body -->
		<JBox class="s-w-full s-h-screen s-overflow-y-scroll s-pb-64" v-if="hasSelectedNode">
			<JBox class="s-pb-64">
				<!-- Classes -->
				<UiEditorInspectorCss v-if="tab === 'design'" />

				<!-- Content -->
				<UiEditorInspectorContent v-if="tab === 'content'" />

				<!-- Props -->
				<UiEditorInspectorProps v-if="tab === 'props'" />
			</JBox>
		</JBox>
	</JBox>
</template>

<script>
import UiEditorInspectorCss from "./UiEditorInspectorCss"
import UiEditorInspectorContent from "./UiEditorInspectorContent"
import UiEditorInspectorProps from "./UiEditorInspectorProps"

export default {
	components: {
		UiEditorInspectorCss,
		UiEditorInspectorContent,
		UiEditorInspectorProps
	},

	data() {
		return {
			tab: "content",
			hasSelectedNode: false
		}
	},

	methods: {
		selectTab(tab) {
			this.tab = tab
		}
	},

	watch: {
		"$store.state.uiEditor.selectedNodeIds": {
			handler() {
				const selectedNode = this.$store.getters["uiEditor/selectedNode"]
				if (!selectedNode) {
					this.hasSelectedNode = false
					return
				}

				this.hasSelectedNode = true
			},
			immediate: true,
			deep: true
		}
	}
}
</script>
